
import React, { useEffect, useState } from "react";
import ProductCard from "./ProductCard";

export default function Recommendations({ recommendations }) {
    const [recs, setRecs] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!recommendations || recommendations.length === 0) {
            setRecs([]);
            return;
        }

        setLoading(true);
        setError(null);

        const fetchAllProducts = async () => {
            try {
                const requests = recommendations.map(id =>
                    fetch(`/api/product/getProductClass/${getProductClassIdFromItemNumber(id)}`)
                        .then(res => res.json())
                        .then(res => res.Content)
                );
                const results = await Promise.all(requests);
                setRecs(results);
                // eslint-disable-next-line no-unused-vars
            } catch (err) {
                setError("Failed to fetch products.");
                setRecs([]);
            } finally {
                setLoading(false);
            }
        };

        fetchAllProducts();
    }, [recommendations]);

    if (!recommendations || recommendations.length === 0) {
        return <RecommendationContainer>No matching recommendation found.</RecommendationContainer>;
    }

    if (loading) {
        return <RecommendationContainer>
            {recommendations.map(id => (<EmptyCard key={id} />))}
        </RecommendationContainer>;
    }

    if (error) {
        return <RecommendationContainer>{error}</RecommendationContainer>;
    }

    return (
        <RecommendationContainer>
            {recs.map(rec => (<ProductCard key={rec.Id} rec={rec} />))}
        </RecommendationContainer>
    );
}

function RecommendationContainer({ children }) {
    return <div className="recommendations">
        <div className="recommendations-label h3">Recommended Products:</div>
        <div className="recommendations-list">
            {children}
        </div>
    </div>;
}

function getProductClassIdFromItemNumber(itemNumber) {
    return itemNumber - 10000;
}

function EmptyCard() {
    return <div className="card-product"></div>;
}




